// extracted by mini-css-extract-plugin
export default {"container":"card-description_container__1IdbU"};